import React from 'react';

import styles from './Switch.module.css';

const Switch = ({ id, value, changed, disabled = false }) => {
    const onValChange = () => {
        changed(id, !value);
    };

    const switchId = `switch${id}`;
    return (
        <>
            <div
                className={`${styles.switchContainer} ${disabled ? styles.disabled : ''}`}
                onClick={(e) => e.stopPropagation()}>
                <label htmlFor={switchId} id={switchId} onClick={onValChange}>
                    <input checked={value || false} onChange={() => {}} className={styles.switch} type="checkbox" />
                    <div>
                        <div></div>
                    </div>
                </label>
            </div>
        </>
    );
};

export default React.memo(Switch);
